import { Bubble } from "./Bubble";

export { OcrWarningBubble };

function OcrWarningBubble() {
  return (
    <Bubble
      className=""
      style={{
        color: "white",
        backgroundColor: "orangered",
      }}
      text={"OCR Warning"}
    />
  );
}
